import { Horizontal, MaterialIcon, Texto, Vertical } from '@gravitate-js/excalibrr'

import type { InvoiceTransaction, TransactionRow } from '../../../../api/useFreight/types'
import type { CustomerOrder } from '../../Launchpad/data'

interface OrderHeaderProps {
  order?: (TransactionRow | InvoiceTransaction | CustomerOrder) | null
  invoiceId?: string
}

export function OrderHeader({ order, invoiceId }: OrderHeaderProps) {
  if (!order) return null

  return (
    <Vertical flex='0' style={{ overflow: 'visible', gap: 8 }} className='p-2'>
      <Vertical className='pb-2' verticalCenter>
        <Texto appearance='hint'>Freight Details for</Texto>
        <Texto category='h3'>Order #{order.order_number}</Texto>
      </Vertical>

      <Horizontal border='top' className='pt-3' style={{ overflow: 'visible' }} gap={8}>
        {order.customer_name && (
          <Vertical flex={1} gap={4}>
            <Texto appearance='hint'>Customer</Texto>
            <Horizontal flex={1} verticalCenter gap={4}>
              <Texto>
                <MaterialIcon fill icon='user_attributes' className='pt-1' size={14} />
              </Texto>
              <Texto weight='600' category='p2'>
                {order.customer_name}
              </Texto>
            </Horizontal>
          </Vertical>
        )}

        {order.carrier_name && (
          <Vertical style={{ overflow: 'visible' }} flex={1} gap={4}>
            <Texto appearance='hint'>Carrier</Texto>
            <Horizontal flex={1} verticalCenter gap={4}>
              <Texto>
                <MaterialIcon fill icon='local_shipping' className='pt-1' size={14} />
              </Texto>
              <Texto style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }} weight='600' category='p2'>
                {order.carrier_name}
              </Texto>
            </Horizontal>
          </Vertical>
        )}
      </Horizontal>
      {invoiceId && <Texto category='p2'>Invoice {invoiceId}</Texto>}
    </Vertical>
  )
}
